import { render, staticRenderFns } from "./purifyalloyStorageHistory.vue?vue&type=template&id=6a61d6b2&scoped=true&"
import script from "./purifyalloyStorageHistory.vue?vue&type=script&lang=js&"
export * from "./purifyalloyStorageHistory.vue?vue&type=script&lang=js&"
import style0 from "./purifyalloyStorageHistory.vue?vue&type=style&index=0&id=6a61d6b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a61d6b2",
  null
  
)

export default component.exports